import { transparentize } from 'polished'
import styled from 'styled-components'

export const ActionWrapper = styled.div`
	align-self: stretch;
	border-left: 1px solid ${({ theme }) => transparentize(0.75, theme.color.textContrast)};
	display: flex;
	justify-content: center;
	margin-left: 6px;
	padding-left: 10px;
`
